import { render, staticRenderFns } from "./CampaignsView.vue?vue&type=template&id=219ff558&scoped=true&"
import script from "./CampaignsView.vue?vue&type=script&lang=ts&"
export * from "./CampaignsView.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignsView.vue?vue&type=style&index=0&id=219ff558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ff558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VIcon,VRow,VTextField})
